/**
 * Feature flag — Clinic-Edit rail consumer surface on the
 * view-appointment-panel (story NEW-W1.3b, gates PROD-1041 mount).
 *
 * Reads `VITE_CLINIC_EDIT_RAIL`. Vite inlines the value at build time,
 * so this resolves on first call and does not subscribe to runtime
 * changes — toggling the flag requires a rebuild.
 *
 * Default: ON in V1.
 * Source: docs/superpowers/sdlc/clinic-edit/02-brds/substrate-reconciliation.md
 *         §7 (tier matrix) / Q2 (2026-06-07) — flag defaults ON in V1.
 *
 * Coercion rules (case-insensitive, trimmed):
 *   - 'true' / '1' / 'on'  → true
 *   - everything else, undefined, empty string → false
 *
 * Mirrors the consumption pattern of `VITE_LAB_LINKAGE_ENABLED`
 * (see `src/components/frames/frame-scheduling.tsx:518-523`), but
 * encapsulates the string-coercion so callers don't repeat it.
 *
 * The .env.example entry ships with `VITE_CLINIC_EDIT_RAIL=true`
 * so a fresh checkout matches the V1 default; CI/prod environments
 * override per the deploy workflow.
 */

import { coerceFlag } from './coerce-flag';

/** Re-exported from its own file (coerce-flag.ts) for the hooks that still import it from here. */
export { coerceFlag };

/**
 * Returns whether the Clinic-Edit rail surface is enabled for the
 * current build. Read once from `import.meta.env.VITE_CLINIC_EDIT_RAIL`.
 *
 * @returns `true` when the flag string coerces to truthy; `false` otherwise.
 */
export function useClinicEditRailEnabled(): boolean {
  return coerceFlag(import.meta.env.VITE_CLINIC_EDIT_RAIL);
}
